var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-form-select", {
    class: { smaller: _vm.smaller },
    attrs: { options: _vm.options },
    on: {
      input: function($event) {
        return _vm.$emit("input", $event)
      },
      change: function($event) {
        return _vm.$emit("change", $event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "first",
        fn: function() {
          return [
            _c(
              "b-form-select-option",
              { attrs: { value: _vm.emptyValue, disabled: "" } },
              [_vm._v(_vm._s(_vm.emptyValueLabel))]
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.selected,
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }